import { NgxChartsModule } from '@swimlane/ngx-charts';
import { AdvancedPieChartComponent } from './components/advanced-pie-chart/advanced-pie-chart.component';
import { NbCardModule, NbLayoutModule, NbSpinnerModule } from '@nebular/theme';
import { NgModule } from '@angular/core';
import { TablesModule } from 'src/ntx-app/components/ngx-components/tables/tables.module';

@NgModule({
  imports: [
    NbLayoutModule,
    NbCardModule,
    NgxChartsModule,
    TablesModule,
    NbSpinnerModule
  ],
  declarations: [
    AdvancedPieChartComponent
  ],
  exports: [
    AdvancedPieChartComponent
  ]
})
export class NTXChartsModule { }
